import axios from 'axios'

export async function getUserReviewedProducts () {
  const URL = '/?fc=module&module=dbs_productsreviews&controller=api&action=getReviewedProducts'
  const response = await axios.get(URL)
  const products = response.data.products

  if (products) {
    return products
  } else {
    throw new Error('Can not get user reviewed products')
  }
}



// WEBPACK FOOTER //
// ./src/api/productReviews/getUserReviewedProducts.js